import { Action, createReducer, on } from '@ngrx/store';

import { Event } from '@planone/bau365/util-fair-data';

import * as DataAccessEventsActions from './data-access-events.actions';

import * as DataAccessExhibitorsActions from '../../exhibitors/entity/data-access-exhibitors.actions';

export const DATA_ACCESS_EVENTS_FEATURE_KEY = 'dataAccessEvents';

export interface EventsState {
  activeEventLoading?: boolean;
  activeEventError?: string;
  events: KeyedEventsList;
}

interface KeyedEventsList {
  [uuid: string]: Event;
}

export interface DataAccessEventsPartialState {
  readonly [DATA_ACCESS_EVENTS_FEATURE_KEY]: EventsState;
}

export const initialEventsState: EventsState = {
  events: {},
};

export const dataAccessEventsReducer = createReducer(
  initialEventsState,
  on(DataAccessEventsActions.eventOpened, (state, { eventUuid }) => {
    const loaded = typeof state.events[eventUuid] !== 'undefined';

    return {
      ...state,
      activeEventLoading: !loaded,
      activeEventError: undefined,
    };
  }),
  on(DataAccessEventsActions.eventLoadSucceeded, (state, { event }) => ({
    ...state,
    activeEventLoading: false,
    activeEventError: undefined,
    events: {
      ...state.events,
      [event.id]: event,
    },
  })),
  on(DataAccessEventsActions.eventLoadFailed, (state, { error }) => ({
    ...state,
    activeEventLoading: false,
    activeEventError: error,
  })),
  on(DataAccessEventsActions.eventsLoadSucceeded, (state, { events }) => {
    let updatedState = state;

    events.forEach((event) => {
      updatedState = {
        ...updatedState,
        events: {
          ...updatedState.events,
          [event.id]: event,
        },
      };
    });

    return updatedState;
  }),
  on(
    DataAccessExhibitorsActions.exhibitorEventsLoadNext,
    DataAccessExhibitorsActions.exhibitorEventsLoadSucceeded,
    (state: EventsState, { exhibitorEventsResponse }) => {
      let object = {};

      exhibitorEventsResponse.items.forEach(
        (event: Event) =>
          (object = {
            ...object,
            [event.id]: event,
          })
      );

      return {
        ...state,
        events: {
          ...state.events,
          ...object,
        },
      };
    }
  )
);

export function eventsReducer(state: EventsState | undefined, action: Action) {
  return dataAccessEventsReducer(state, action);
}
